import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Dialog, Paper } from '@mui/material';
import { closeAllModals } from 'reducers/modalReducer';
import EmbeddedIFrame from 'views/Frames/EmbeddedIFrame';
import ContactNote, { EmailAddress } from 'types/ContactNote';
import { usePostMessageToIFrame } from 'hooks/usePostMessageToIFrame';
import { ClmPortalIncomingPostMessageTypes } from 'utils/postMessageUtil';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import PageTitleToken from 'components/Common/PageTitleToken';

export type ContactNoteFromEmail = ContactNote & {
  addEmailToPartner: boolean;
  incomingOutgoing: boolean;
  involvedRoles: string[];
  body: string;
  from: EmailAddress;
  to: EmailAddress[];
  cc: EmailAddress[];
  bcc: EmailAddress[];
};

type Props = {
  contactNoteEmailData: ContactNoteFromEmail;
};

const ContactNoteFromEmailModal = ({ contactNoteEmailData }: Props) => {
  const dispatch = useDispatch();
  const { postMessageToIFrame } = usePostMessageToIFrame();
  const runtimeConfig = useRuntimeConfig();

  const wn = document.getElementById('contact-notes-iframe') as HTMLIFrameElement;
  if (wn) postMessageToIFrame(contactNoteEmailData, wn);

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    function handleMessage(event: any) {
      const message = event.data.message;
      if (message === ClmPortalIncomingPostMessageTypes.CLOSE_CONTACT_NOTE_MODAL) {
        dispatch(closeAllModals());
      }
      if (message === ClmPortalIncomingPostMessageTypes.SEND_CONTACT_NOTE_DATA) {
        const wn = document.getElementById('contact-note-from-email-iframe') as HTMLIFrameElement;
        if (!!wn && !!contactNoteEmailData) postMessageToIFrame(contactNoteEmailData, wn);
      }
    }

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <Dialog
      id="contact-note-from-email-modal"
      open={true}
      fullWidth={true}
      aria-labelledby="dialog-title"
      PaperProps={{ style: { height: '100%' } }}
      PaperComponent={Paper}
      maxWidth="md"
      onClose={() => dispatch(closeAllModals())}
      style={{ height: '100%' }}
    >
      <PageTitleToken />
      <EmbeddedIFrame
        url={`${runtimeConfig.configData.iframeUrls.contactNoteIframe}/note-from-email`}
        title="Contact notes"
        id="contact-note-from-email-iframe"
        height="100%"
        centered
      />
    </Dialog>
  );
};

export default ContactNoteFromEmailModal;
